function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" {...props}><g fill="none" fillRule="evenodd"><circle cx="16.5" cy="16.5" r="16.5" fill="#F6F7FB" /><path fill="#6A6D7B" fillRule="nonzero" d="M20 22.838L14.949 7.684c-.304-.912-1.594-.912-1.898 0L10.28 16H7a1 1 0 1 0 0 2h4a1 1 0 0 0 .949-.684L14 11.162l5.051 15.154c.304.912 1.594.912 1.898 0L23.72 18H27a1 1 0 0 0 0-2h-4a1 1 0 0 0-.949.684L20 22.838z" /></g></svg>;
});